"use strict";

define('rs/modals/meeting.finder/meeting.finder.view',['rs/modals/table.finder/table.finder.view'], function (FinderView) {
  var MeetingFinderView = FinderView.extend({
    handleCreateMeetingAction: function handleCreateMeetingAction() {
      this.getDelegate().requestCreateMeeting();
    }
  });
  return MeetingFinderView;
});

